import { Region } from '@/api/types/regions.types';

const regionsMockAz = {
  topRegions: [
    {
      name: 'Bakı',
      legacyResourceId: 420,
      __typename: 'Region',
    },
    {
      name: 'Sumqayıt',
      legacyResourceId: 419,
      __typename: 'Region',
    },
    {
      name: 'Xırdalan',
      legacyResourceId: 450,
      __typename: 'Region',
    },
    {
      name: 'Gəncə',
      legacyResourceId: 418,
      __typename: 'Region',
    },
    {
      name: 'Quba',
      legacyResourceId: 425,
      __typename: 'Region',
    },
    {
      name: 'Xaçmaz',
      legacyResourceId: 448,
      __typename: 'Region',
    },
    {
      name: 'Lənkəran',
      legacyResourceId: 424,
      __typename: 'Region',
    },
    {
      name: 'Şəki',
      legacyResourceId: 460,
      __typename: 'Region',
    },
    {
      name: 'Mingəçevir',
      legacyResourceId: 421,
      __typename: 'Region',
    },
    {
      name: 'Qusar',
      legacyResourceId: 442,
      __typename: 'Region',
    },
    {
      name: 'Şirvan',
      legacyResourceId: 459,
      __typename: 'Region',
    },
    {
      name: 'Qəbələ',
      legacyResourceId: 426,
      __typename: 'Region',
    },
    {
      name: 'Zaqatala',
      legacyResourceId: 453,
      __typename: 'Region',
    },
    {
      name: 'Masallı',
      legacyResourceId: 438,
      __typename: 'Region',
    },
  ],
  otherRegions: [
    {
      name: 'Ağcabədi',
      legacyResourceId: 468,
      __typename: 'Region',
    },
    {
      name: 'Ağdam',
      legacyResourceId: 478,
      __typename: 'Region',
    },
    {
      name: 'Ağdaş',
      legacyResourceId: 429,
      __typename: 'Region',
    },
    {
      name: 'Ağdərə',
      legacyResourceId: 481,
      __typename: 'Region',
    },
    {
      name: 'Ağstafa',
      legacyResourceId: 430,
      __typename: 'Region',
    },
    {
      name: 'Ağsu',
      legacyResourceId: 470,
      __typename: 'Region',
    },
    {
      name: 'Astara',
      legacyResourceId: 428,
      __typename: 'Region',
    },
    {
      name: 'Balakən',
      legacyResourceId: 423,
      __typename: 'Region',
    },
    {
      name: 'Beyləqan',
      legacyResourceId: 431,
      __typename: 'Region',
    },
    {
      name: 'Bərdə',
      legacyResourceId: 433,
      __typename: 'Region',
    },
    {
      name: 'Biləsuvar',
      legacyResourceId: 432,
      __typename: 'Region',
    },
    {
      name: 'Cəbrayıl',
      legacyResourceId: 482,
      __typename: 'Region',
    },
    {
      name: 'Cəlilabad',
      legacyResourceId: 434,
      __typename: 'Region',
    },
    {
      name: 'Culfa',
      legacyResourceId: 472,
      __typename: 'Region',
    },
    {
      name: 'Daşkəsən',
      legacyResourceId: 475,
      __typename: 'Region',
    },
    {
      name: 'Füzuli',
      legacyResourceId: 467,
      __typename: 'Region',
    },
    {
      name: 'Gədəbəy',
      legacyResourceId: 474,
      __typename: 'Region',
    },
    {
      name: 'Goranboy',
      legacyResourceId: 477,
      __typename: 'Region',
    },
    {
      name: 'Göyçay',
      legacyResourceId: 436,
      __typename: 'Region',
    },
    {
      name: 'Göygöl',
      legacyResourceId: 469,
      __typename: 'Region',
    },
    {
      name: 'Göytəpə',
      legacyResourceId: 435,
      __typename: 'Region',
    },
    {
      name: 'Hacıqabul',
      legacyResourceId: 437,
      __typename: 'Region',
    },
    {
      name: 'Horadiz',
      legacyResourceId: 466,
      __typename: 'Region',
    },
    {
      name: 'İmişli',
      legacyResourceId: 455,
      __typename: 'Region',
    },
    {
      name: 'İsmayıllı',
      legacyResourceId: 456,
      __typename: 'Region',
    },
    {
      name: 'Kəlbəcər',
      legacyResourceId: 484,
      __typename: 'Region',
    },
    {
      name: 'Kürdəmir',
      legacyResourceId: 473,
      __typename: 'Region',
    },
    {
      name: 'Laçın',
      legacyResourceId: 486,
      __typename: 'Region',
    },
    {
      name: 'Lerik',
      legacyResourceId: 479,
      __typename: 'Region',
    },
    {
      name: 'Nabran',
      legacyResourceId: 462,
      __typename: 'Region',
    },
    {
      name: 'Naftalan',
      legacyResourceId: 476,
      __typename: 'Region',
    },
    {
      name: 'Naxçıvan',
      legacyResourceId: 422,
      __typename: 'Region',
    },
    {
      name: 'Neftçala',
      legacyResourceId: 439,
      __typename: 'Region',
    },
    {
      name: 'Oğuz',
      legacyResourceId: 440,
      __typename: 'Region',
    },
    {
      name: 'Ordubad',
      legacyResourceId: 492,
      __typename: 'Region',
    },
    {
      name: 'Qax',
      legacyResourceId: 441,
      __typename: 'Region',
    },
    {
      name: 'Qazax',
      legacyResourceId: 463,
      __typename: 'Region',
    },
    {
      name: 'Qobustan',
      legacyResourceId: 464,
      __typename: 'Region',
    },
    {
      name: 'Qubadlı',
      legacyResourceId: 485,
      __typename: 'Region',
    },
    {
      name: 'Saatlı',
      legacyResourceId: 443,
      __typename: 'Region',
    },
    {
      name: 'Sabirabad',
      legacyResourceId: 444,
      __typename: 'Region',
    },
    {
      name: 'Şabran',
      legacyResourceId: 457,
      __typename: 'Region',
    },
    {
      name: 'Şahbuz',
      legacyResourceId: 494,
      __typename: 'Region',
    },
    {
      name: 'Salyan',
      legacyResourceId: 445,
      __typename: 'Region',
    },
    {
      name: 'Şamaxı',
      legacyResourceId: 458,
      __typename: 'Region',
    },
    {
      name: 'Samux',
      legacyResourceId: 487,
      __typename: 'Region',
    },
    {
      name: 'Şəmkir',
      legacyResourceId: 461,
      __typename: 'Region',
    },
    {
      name: 'Şərur',
      legacyResourceId: 493,
      __typename: 'Region',
    },
    {
      name: 'Siyəzən',
      legacyResourceId: 446,
      __typename: 'Region',
    },
    {
      name: 'Şuşa',
      legacyResourceId: 491,
      __typename: 'Region',
    },
    {
      name: 'Tərtər',
      legacyResourceId: 471,
      __typename: 'Region',
    },
    {
      name: 'Tovuz',
      legacyResourceId: 447,
      __typename: 'Region',
    },
    {
      name: 'Ucar',
      legacyResourceId: 465,
      __typename: 'Region',
    },
    {
      name: 'Xankəndi',
      legacyResourceId: 488,
      __typename: 'Region',
    },
    {
      name: 'Xızı',
      legacyResourceId: 451,
      __typename: 'Region',
    },
    {
      name: 'Xocalı',
      legacyResourceId: 490,
      __typename: 'Region',
    },
    {
      name: 'Xocavənd',
      legacyResourceId: 489,
      __typename: 'Region',
    },
    {
      name: 'Xudat',
      legacyResourceId: 449,
      __typename: 'Region',
    },
    {
      name: 'Yardımlı',
      legacyResourceId: 480,
      __typename: 'Region',
    },
    {
      name: 'Yevlax',
      legacyResourceId: 452,
      __typename: 'Region',
    },
    {
      name: 'Zəngilan',
      legacyResourceId: 483,
      __typename: 'Region',
    },
    {
      name: 'Zərdab',
      legacyResourceId: 454,
      __typename: 'Region',
    },
  ],
  regions: [
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njg',
      legacyResourceId: 468,
      name: 'Ağcabədi',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzg',
      legacyResourceId: 478,
      name: 'Ağdam',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mjk',
      legacyResourceId: 429,
      name: 'Ağdaş',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODE',
      legacyResourceId: 481,
      name: 'Ağdərə',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzA',
      legacyResourceId: 430,
      name: 'Ağstafa',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzA',
      legacyResourceId: 470,
      name: 'Ağsu',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mjg',
      legacyResourceId: 428,
      name: 'Astara',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjA',
      legacyResourceId: 420,
      name: 'Bakı',
      default: true,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjM',
      legacyResourceId: 423,
      name: 'Balakən',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzE',
      legacyResourceId: 431,
      name: 'Beyləqan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzM',
      legacyResourceId: 433,
      name: 'Bərdə',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzI',
      legacyResourceId: 432,
      name: 'Biləsuvar',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODI',
      legacyResourceId: 482,
      name: 'Cəbrayıl',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzQ',
      legacyResourceId: 434,
      name: 'Cəlilabad',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzI',
      legacyResourceId: 472,
      name: 'Culfa',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzU',
      legacyResourceId: 475,
      name: 'Daşkəsən',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njc',
      legacyResourceId: 467,
      name: 'Füzuli',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzQ',
      legacyResourceId: 474,
      name: 'Gədəbəy',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MTg',
      legacyResourceId: 418,
      name: 'Gəncə',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzc',
      legacyResourceId: 477,
      name: 'Goranboy',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzY',
      legacyResourceId: 436,
      name: 'Göyçay',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njk',
      legacyResourceId: 469,
      name: 'Göygöl',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzU',
      legacyResourceId: 435,
      name: 'Göytəpə',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzc',
      legacyResourceId: 437,
      name: 'Hacıqabul',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjY',
      legacyResourceId: 466,
      name: 'Horadiz',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTU',
      legacyResourceId: 455,
      name: 'İmişli',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTY',
      legacyResourceId: 456,
      name: 'İsmayıllı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODQ',
      legacyResourceId: 484,
      name: 'Kəlbəcər',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzM',
      legacyResourceId: 473,
      name: 'Kürdəmir',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODY',
      legacyResourceId: 486,
      name: 'Laçın',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzk',
      legacyResourceId: 479,
      name: 'Lerik',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjQ',
      legacyResourceId: 424,
      name: 'Lənkəran',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzg',
      legacyResourceId: 438,
      name: 'Masallı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjE',
      legacyResourceId: 421,
      name: 'Mingəçevir',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjI',
      legacyResourceId: 462,
      name: 'Nabran',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzY',
      legacyResourceId: 476,
      name: 'Naftalan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjI',
      legacyResourceId: 422,
      name: 'Naxçıvan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzk',
      legacyResourceId: 439,
      name: 'Neftçala',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDA',
      legacyResourceId: 440,
      name: 'Oğuz',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTI',
      legacyResourceId: 492,
      name: 'Ordubad',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDE',
      legacyResourceId: 441,
      name: 'Qax',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjM',
      legacyResourceId: 463,
      name: 'Qazax',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjY',
      legacyResourceId: 426,
      name: 'Qəbələ',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjQ',
      legacyResourceId: 464,
      name: 'Qobustan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjU',
      legacyResourceId: 425,
      name: 'Quba',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODU',
      legacyResourceId: 485,
      name: 'Qubadlı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDI',
      legacyResourceId: 442,
      name: 'Qusar',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDM',
      legacyResourceId: 443,
      name: 'Saatlı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDQ',
      legacyResourceId: 444,
      name: 'Sabirabad',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTc',
      legacyResourceId: 457,
      name: 'Şabran',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTQ',
      legacyResourceId: 494,
      name: 'Şahbuz',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDU',
      legacyResourceId: 445,
      name: 'Salyan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTg',
      legacyResourceId: 458,
      name: 'Şamaxı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODc',
      legacyResourceId: 487,
      name: 'Samux',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjA',
      legacyResourceId: 460,
      name: 'Şəki',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjE',
      legacyResourceId: 461,
      name: 'Şəmkir',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTM',
      legacyResourceId: 493,
      name: 'Şərur',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTk',
      legacyResourceId: 459,
      name: 'Şirvan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDY',
      legacyResourceId: 446,
      name: 'Siyəzən',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MTk',
      legacyResourceId: 419,
      name: 'Sumqayıt',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTE',
      legacyResourceId: 491,
      name: 'Şuşa',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzE',
      legacyResourceId: 471,
      name: 'Tərtər',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDc',
      legacyResourceId: 447,
      name: 'Tovuz',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjU',
      legacyResourceId: 465,
      name: 'Ucar',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDg',
      legacyResourceId: 448,
      name: 'Xaçmaz',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODg',
      legacyResourceId: 488,
      name: 'Xankəndi',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTA',
      legacyResourceId: 450,
      name: 'Xırdalan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTE',
      legacyResourceId: 451,
      name: 'Xızı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTA',
      legacyResourceId: 490,
      name: 'Xocalı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODk',
      legacyResourceId: 489,
      name: 'Xocavənd',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDk',
      legacyResourceId: 449,
      name: 'Xudat',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODA',
      legacyResourceId: 480,
      name: 'Yardımlı',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTI',
      legacyResourceId: 452,
      name: 'Yevlax',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTM',
      legacyResourceId: 453,
      name: 'Zaqatala',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODM',
      legacyResourceId: 483,
      name: 'Zəngilan',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTQ',
      legacyResourceId: 454,
      name: 'Zərdab',
      default: false,
      __typename: 'Region',
    },
  ],
};

const regionsMockRu = {
  regions: [
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzg',
      legacyResourceId: 478,
      name: 'Агдам',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mjk',
      legacyResourceId: 429,
      name: 'Агдаш',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODE',
      legacyResourceId: 481,
      name: 'Агдере',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njg',
      legacyResourceId: 468,
      name: 'Агджабеди',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzA',
      legacyResourceId: 430,
      name: 'Агстафа',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mjg',
      legacyResourceId: 428,
      name: 'Астара',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzA',
      legacyResourceId: 470,
      name: 'Ахсу',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjA',
      legacyResourceId: 420,
      name: 'Баку',
      default: true,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjM',
      legacyResourceId: 423,
      name: 'Балакен',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzE',
      legacyResourceId: 431,
      name: 'Бейлаган',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzI',
      legacyResourceId: 432,
      name: 'Билясувар',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzM',
      legacyResourceId: 433,
      name: 'Бярда',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjY',
      legacyResourceId: 426,
      name: 'Габала',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzc',
      legacyResourceId: 437,
      name: 'Гаджигабул',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjM',
      legacyResourceId: 463,
      name: 'Газах',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDE',
      legacyResourceId: 441,
      name: 'Гах',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzc',
      legacyResourceId: 477,
      name: 'Геранбой',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjQ',
      legacyResourceId: 464,
      name: 'Гобустан',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzU',
      legacyResourceId: 435,
      name: 'Гойтепе',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzY',
      legacyResourceId: 436,
      name: 'Гойчай',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjY',
      legacyResourceId: 466,
      name: 'Горадиз',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjU',
      legacyResourceId: 425,
      name: 'Губа',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDI',
      legacyResourceId: 442,
      name: 'Гусар',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MTg',
      legacyResourceId: 418,
      name: 'Гянджа',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njk',
      legacyResourceId: 469,
      name: 'Гёйгёль',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzU',
      legacyResourceId: 475,
      name: 'Дашкесан',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MzQ',
      legacyResourceId: 434,
      name: 'Джалилабад',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODI',
      legacyResourceId: 482,
      name: 'Джебраил',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzI',
      legacyResourceId: 472,
      name: 'Джульфа',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTI',
      legacyResourceId: 452,
      name: 'Евлах',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTM',
      legacyResourceId: 453,
      name: 'Загатала',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODM',
      legacyResourceId: 483,
      name: 'Зангелан',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTQ',
      legacyResourceId: 454,
      name: 'Зардаб',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTU',
      legacyResourceId: 455,
      name: 'Имишли',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTY',
      legacyResourceId: 456,
      name: 'Исмаиллы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzQ',
      legacyResourceId: 474,
      name: 'Кедабек',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODQ',
      legacyResourceId: 484,
      name: 'Кельбаджар',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODU',
      legacyResourceId: 485,
      name: 'Кубатлы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzM',
      legacyResourceId: 473,
      name: 'Кюрдамир',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODY',
      legacyResourceId: 486,
      name: 'Лачин',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Nzk',
      legacyResourceId: 479,
      name: 'Лерик',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjQ',
      legacyResourceId: 424,
      name: 'Лянкяран',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzg',
      legacyResourceId: 438,
      name: 'Масаллы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjE',
      legacyResourceId: 421,
      name: 'Мингячевир',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjI',
      legacyResourceId: 462,
      name: 'Набрань',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzY',
      legacyResourceId: 476,
      name: 'Нафталан',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MjI',
      legacyResourceId: 422,
      name: 'Нахчыван',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Mzk',
      legacyResourceId: 439,
      name: 'Нефтчала',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDA',
      legacyResourceId: 440,
      name: 'Огуз',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTI',
      legacyResourceId: 492,
      name: 'Ордубад',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDM',
      legacyResourceId: 443,
      name: 'Саатлы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDQ',
      legacyResourceId: 444,
      name: 'Сабирабад',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDU',
      legacyResourceId: 445,
      name: 'Сальян',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODc',
      legacyResourceId: 487,
      name: 'Самух',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDY',
      legacyResourceId: 446,
      name: 'Сиязань',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80MTk',
      legacyResourceId: 419,
      name: 'Сумгаит',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NzE',
      legacyResourceId: 471,
      name: 'Тертер',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDc',
      legacyResourceId: 447,
      name: 'Товуз',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjU',
      legacyResourceId: 465,
      name: 'Уджар',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80Njc',
      legacyResourceId: 467,
      name: 'Физули',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODg',
      legacyResourceId: 488,
      name: 'Ханкенди',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDg',
      legacyResourceId: 448,
      name: 'Хачмаз',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODk',
      legacyResourceId: 489,
      name: 'Ходжавенд',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTA',
      legacyResourceId: 490,
      name: 'Ходжалы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NDk',
      legacyResourceId: 449,
      name: 'Худат',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTE',
      legacyResourceId: 451,
      name: 'Хызы',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTA',
      legacyResourceId: 450,
      name: 'Хырдалан',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTc',
      legacyResourceId: 457,
      name: 'Шабран',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTM',
      legacyResourceId: 493,
      name: 'Шарур',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTQ',
      legacyResourceId: 494,
      name: 'Шахбуз',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjA',
      legacyResourceId: 460,
      name: 'Шеки',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTg',
      legacyResourceId: 458,
      name: 'Шемаха',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NjE',
      legacyResourceId: 461,
      name: 'Шемкир',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80NTk',
      legacyResourceId: 459,
      name: 'Ширван',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80OTE',
      legacyResourceId: 491,
      name: 'Шуша',
      default: false,
      __typename: 'Region',
    },
    {
      id: 'Z2lkOi8vdGFwL1JlZ2lvbi80ODA',
      legacyResourceId: 480,
      name: 'Ярдымлы',
      default: false,
      __typename: 'Region',
    },
  ],
  topRegions: [
    {
      name: 'Баку',
      legacyResourceId: 420,
      __typename: 'Region',
    },
    {
      name: 'Сумгаит',
      legacyResourceId: 419,
      __typename: 'Region',
    },
    {
      name: 'Хырдалан',
      legacyResourceId: 450,
      __typename: 'Region',
    },
    {
      name: 'Гянджа',
      legacyResourceId: 418,
      __typename: 'Region',
    },
    {
      name: 'Губа',
      legacyResourceId: 425,
      __typename: 'Region',
    },
    {
      name: 'Хачмаз',
      legacyResourceId: 448,
      __typename: 'Region',
    },
    {
      name: 'Лянкяран',
      legacyResourceId: 424,
      __typename: 'Region',
    },
    {
      name: 'Шеки',
      legacyResourceId: 460,
      __typename: 'Region',
    },
    {
      name: 'Мингячевир',
      legacyResourceId: 421,
      __typename: 'Region',
    },
    {
      name: 'Гусар',
      legacyResourceId: 442,
      __typename: 'Region',
    },
    {
      name: 'Ширван',
      legacyResourceId: 459,
      __typename: 'Region',
    },
    {
      name: 'Габала',
      legacyResourceId: 426,
      __typename: 'Region',
    },
    {
      name: 'Загатала',
      legacyResourceId: 453,
      __typename: 'Region',
    },
    {
      name: 'Масаллы',
      legacyResourceId: 438,
      __typename: 'Region',
    },
  ],
  otherRegions: [
    {
      name: 'Агдам',
      legacyResourceId: 478,
      __typename: 'Region',
    },
    {
      name: 'Агдаш',
      legacyResourceId: 429,
      __typename: 'Region',
    },
    {
      name: 'Агдере',
      legacyResourceId: 481,
      __typename: 'Region',
    },
    {
      name: 'Агджабеди',
      legacyResourceId: 468,
      __typename: 'Region',
    },
    {
      name: 'Агстафа',
      legacyResourceId: 430,
      __typename: 'Region',
    },
    {
      name: 'Астара',
      legacyResourceId: 428,
      __typename: 'Region',
    },
    {
      name: 'Ахсу',
      legacyResourceId: 470,
      __typename: 'Region',
    },
    {
      name: 'Балакен',
      legacyResourceId: 423,
      __typename: 'Region',
    },
    {
      name: 'Бейлаган',
      legacyResourceId: 431,
      __typename: 'Region',
    },
    {
      name: 'Билясувар',
      legacyResourceId: 432,
      __typename: 'Region',
    },
    {
      name: 'Бярда',
      legacyResourceId: 433,
      __typename: 'Region',
    },
    {
      name: 'Гаджигабул',
      legacyResourceId: 437,
      __typename: 'Region',
    },
    {
      name: 'Газах',
      legacyResourceId: 463,
      __typename: 'Region',
    },
    {
      name: 'Гах',
      legacyResourceId: 441,
      __typename: 'Region',
    },
    {
      name: 'Геранбой',
      legacyResourceId: 477,
      __typename: 'Region',
    },
    {
      name: 'Гобустан',
      legacyResourceId: 464,
      __typename: 'Region',
    },
    {
      name: 'Гойтепе',
      legacyResourceId: 435,
      __typename: 'Region',
    },
    {
      name: 'Гойчай',
      legacyResourceId: 436,
      __typename: 'Region',
    },
    {
      name: 'Горадиз',
      legacyResourceId: 466,
      __typename: 'Region',
    },
    {
      name: 'Гёйгёль',
      legacyResourceId: 469,
      __typename: 'Region',
    },
    {
      name: 'Дашкесан',
      legacyResourceId: 475,
      __typename: 'Region',
    },
    {
      name: 'Джалилабад',
      legacyResourceId: 434,
      __typename: 'Region',
    },
    {
      name: 'Джебраил',
      legacyResourceId: 482,
      __typename: 'Region',
    },
    {
      name: 'Джульфа',
      legacyResourceId: 472,
      __typename: 'Region',
    },
    {
      name: 'Евлах',
      legacyResourceId: 452,
      __typename: 'Region',
    },
    {
      name: 'Зангелан',
      legacyResourceId: 483,
      __typename: 'Region',
    },
    {
      name: 'Зардаб',
      legacyResourceId: 454,
      __typename: 'Region',
    },
    {
      name: 'Имишли',
      legacyResourceId: 455,
      __typename: 'Region',
    },
    {
      name: 'Исмаиллы',
      legacyResourceId: 456,
      __typename: 'Region',
    },
    {
      name: 'Кедабек',
      legacyResourceId: 474,
      __typename: 'Region',
    },
    {
      name: 'Кельбаджар',
      legacyResourceId: 484,
      __typename: 'Region',
    },
    {
      name: 'Кубатлы',
      legacyResourceId: 485,
      __typename: 'Region',
    },
    {
      name: 'Кюрдамир',
      legacyResourceId: 473,
      __typename: 'Region',
    },
    {
      name: 'Лачин',
      legacyResourceId: 486,
      __typename: 'Region',
    },
    {
      name: 'Лерик',
      legacyResourceId: 479,
      __typename: 'Region',
    },
    {
      name: 'Набрань',
      legacyResourceId: 462,
      __typename: 'Region',
    },
    {
      name: 'Нафталан',
      legacyResourceId: 476,
      __typename: 'Region',
    },
    {
      name: 'Нахчыван',
      legacyResourceId: 422,
      __typename: 'Region',
    },
    {
      name: 'Нефтчала',
      legacyResourceId: 439,
      __typename: 'Region',
    },
    {
      name: 'Огуз',
      legacyResourceId: 440,
      __typename: 'Region',
    },
    {
      name: 'Ордубад',
      legacyResourceId: 492,
      __typename: 'Region',
    },
    {
      name: 'Саатлы',
      legacyResourceId: 443,
      __typename: 'Region',
    },
    {
      name: 'Сабирабад',
      legacyResourceId: 444,
      __typename: 'Region',
    },
    {
      name: 'Сальян',
      legacyResourceId: 445,
      __typename: 'Region',
    },
    {
      name: 'Самух',
      legacyResourceId: 487,
      __typename: 'Region',
    },
    {
      name: 'Сиязань',
      legacyResourceId: 446,
      __typename: 'Region',
    },
    {
      name: 'Тертер',
      legacyResourceId: 471,
      __typename: 'Region',
    },
    {
      name: 'Товуз',
      legacyResourceId: 447,
      __typename: 'Region',
    },
    {
      name: 'Уджар',
      legacyResourceId: 465,
      __typename: 'Region',
    },
    {
      name: 'Физули',
      legacyResourceId: 467,
      __typename: 'Region',
    },
    {
      name: 'Ханкенди',
      legacyResourceId: 488,
      __typename: 'Region',
    },
    {
      name: 'Ходжавенд',
      legacyResourceId: 489,
      __typename: 'Region',
    },
    {
      name: 'Ходжалы',
      legacyResourceId: 490,
      __typename: 'Region',
    },
    {
      name: 'Худат',
      legacyResourceId: 449,
      __typename: 'Region',
    },
    {
      name: 'Хызы',
      legacyResourceId: 451,
      __typename: 'Region',
    },
    {
      name: 'Шабран',
      legacyResourceId: 457,
      __typename: 'Region',
    },
    {
      name: 'Шарур',
      legacyResourceId: 493,
      __typename: 'Region',
    },
    {
      name: 'Шахбуз',
      legacyResourceId: 494,
      __typename: 'Region',
    },
    {
      name: 'Шемаха',
      legacyResourceId: 458,
      __typename: 'Region',
    },
    {
      name: 'Шемкир',
      legacyResourceId: 461,
      __typename: 'Region',
    },
    {
      name: 'Шуша',
      legacyResourceId: 491,
      __typename: 'Region',
    },
    {
      name: 'Ярдымлы',
      legacyResourceId: 480,
      __typename: 'Region',
    },
  ],
};

export const regionsMock = (locale: string) =>
  (locale === 'ru' ? regionsMockRu : regionsMockAz) as unknown as {
    regions: Region[];
    topRegions: Region[];
    otherRegions: Region[];
  };
